import { IconProps } from 'types/icon.type'

export const MastercardIcon = (props: IconProps) => {
  return (
    <svg
      width="55"
      height="32"
      viewBox="0 0 55 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Mastercard Logo</title>
      <rect x="0.5" width="54" height="32" rx="6" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.5 23.0091C25.9112 24.3633 23.8503 25.1807 21.5984 25.1807C16.5735 25.1807 12.5 21.1108 12.5 16.0904C12.5 11.0699 16.5735 7 21.5984 7C23.8503 7 25.9112 7.81745 27.5 9.17156C29.0888 7.81745 31.1496 7 33.4016 7C38.4265 7 42.5 11.0699 42.5 16.0904C42.5 21.1108 38.4265 25.1807 33.4016 25.1807C31.1496 25.1807 29.0888 24.3633 27.5 23.0091Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.5 23.0091C29.4563 21.3418 30.6967 18.8608 30.6967 16.0904C30.6967 13.3199 29.4563 10.8389 27.5 9.17156C29.0888 7.81745 31.1496 7 33.4016 7C38.4265 7 42.5 11.0699 42.5 16.0904C42.5 21.1108 38.4265 25.1807 33.4016 25.1807C31.1496 25.1807 29.0888 24.3633 27.5 23.0091Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.4999 23.0092C29.4562 21.3418 30.6966 18.8608 30.6966 16.0904C30.6966 13.3199 29.4562 10.8389 27.4999 9.17161C25.5437 10.8389 24.3032 13.3199 24.3032 16.0904C24.3032 18.8608 25.5437 21.3418 27.4999 23.0092Z"
        fill="#FF5E00"
      />
    </svg>
  )
}
